import Link from "@/components/common/Link";
import Image from "@/components/common/Image";
import { useI18n } from "@/common/I18nProvider";

export default function FaqHomeOne() {
  const { messages, lang } = useI18n();
  const faq = messages.faq;
  const questions = faq.questions;

  const faqItems = [
    { id: 'faqQuestion1', question: questions.q1.question, answer: questions.q1.answer, expanded: true },
    { id: 'faqQuestion2', question: questions.q2.question, answer: questions.q2.answer, expanded: false },
    { id: 'faqQuestion3', question: questions.q3.question, answer: questions.q3.answer, expanded: false },
    { id: 'faqQuestion4', question: questions.q4.question, answer: questions.q4.answer, expanded: false },
    { id: 'faqQuestion5', question: questions.q5.question, answer: questions.q5.answer, expanded: false },
  ];
 
  return (
    <section className="faq-section">
      {/* <!-- Divider --> */}
      <div className="divider"></div>

      <div className="container">
        <div className="row g-5">
          {/* <!-- Section Heading --> */}
          <div className="col-12 col-md-6">
            <div className="section-heading pe-xxl-5">
              <span className="subtitle">{faq.subtitle}</span>
              <h2 className="mb-4">{faq.title}</h2>
              <p className="mb-5">{faq.description}</p>
              <Link href="/contact" className="btn btn-primary">
                <span>{faq.askQuestion} <i className="ti ti-arrow-up-right"></i></span>
                <span>{faq.askQuestion} <i className="ti ti-arrow-up-right"></i></span>
              </Link>
              {/* <!-- Question Mark --> */}
              <div className="question-mark">
                <Image className="w-auto h-auto" data-speed="0.8" src="/assets/img/core-img/question-mark.png" alt="" width={1920} height={1080} priority/>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            {/* <!-- FAQ Accordion --> */}
            <div className="faq-accordion">
              <div className="accordion" id={`faqAccordion-${lang}`} key={`faq-accordion-${lang}`}>
                {faqItems.map((item) => (
                  <div key={`${item.id}-${lang}`} className="accordion-item">
                    <div className="accordion-header">
                      <button 
                        className={`accordion-button ${item.expanded ? '' : 'collapsed'}`} 
                        type="button" 
                        data-bs-toggle="collapse"
                        data-bs-target={`#${item.id}-${lang}`} 
                        aria-expanded={item.expanded} 
                        aria-controls={`${item.id}-${lang}`}>
                        {item.question}
                      </button>
                    </div>
                    <div 
                      id={`${item.id}-${lang}`} 
                      className={`accordion-collapse collapse ${item.expanded ? 'show' : ''}`}
                      data-bs-parent={`#faqAccordion-${lang}`}>
                      <div className="accordion-body">
                        {item.answer}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Divider --> */}
      <div className="divider"></div>
    </section>
  )
}
